import React from 'react';
import t from 'react-translate';
import { css } from '@emotion/react';

// redux
import { useAppDispatch } from 'redux/store';
import { useSelector } from 'react-redux';
import { getCurrentLecture, getNovoAIProperties } from 'redux/selectors/lecture-page';
import { getCurrentInstitution } from 'redux/selectors/institutions';
import { setBottomBarVisibility, setLeftPanelAiMode } from 'redux/actions/lecture-pages';
import { NovoAIContentType, NovoAIItemType } from 'redux/schemas/models/lecture-page';

// hooks
import { useLecturePageParams } from 'lecture_pages/hooks/lecture-routing';

// components
import { hideAddUI } from 'lecture_pages/templates/components/nv-add-component';
import TopPanelActionButton from './top-panel-action-button';

import { config } from '../../../../../config/config.json';

const AiSuggestActivityButton = () => {
  const params = useLecturePageParams();
  const dispatch = useAppDispatch();

  const currentLecture = useSelector(getCurrentLecture);
  const currentInstitution = useSelector(getCurrentInstitution);
  const leftPanelView = useSelector(state => state.app.lecturePage.leftPanelView);
  const { itemType } = useSelector(getNovoAIProperties);

  const isLinkedLesson = !currentLecture?.isLinked;

  const styles = css`
    .suggest-ai-btn {
      ${itemType === NovoAIItemType.SUGGEST_ACTIVITIES && (`
        background: linear-gradient(48.41deg, #60F3AB 0%, #00CCBC 45%, #009AC0 100%);
      `)}
    }
  `;

  const showLHSActivitySuggestions = () => {
    if (leftPanelView === 'novo_ai') {
      hideAddUI(dispatch);
    } else {
      dispatch(setBottomBarVisibility(false));
      dispatch(setLeftPanelAiMode({
        itemType: NovoAIItemType.SUGGEST_ACTIVITIES,
        content: {
          id: params.lecturePageId,
          type: NovoAIContentType.LESSON,
        },
      }));
    }
  };

  return (
    <div className='ml-4' css={styles}>
      {currentInstitution.hasAiComponentGeneration && (
        <TopPanelActionButton
          icon='gen-ai'
          tooltipText={isLinkedLesson
            ? t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.AI_SUGGEST_ACTIVITY()
            : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.AI_SUGGEST_ACTIVITY_DISABLED_TEXT()}
          disabled={!isLinkedLesson}
          onClick={showLHSActivitySuggestions}
          className='suggest-ai-btn'
          ariaLabel={isLinkedLesson
            ? t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.AI_SUGGEST_ACTIVITY()
            : t.LECTURE_PAGES.ADMIN.EDIT_MENU_TOP_HEADER.AI_SUGGEST_ACTIVITY_DISABLED_TEXT()}
          dataQa={config.pendo.lectureEdit.editMenuTopPanel.aiSuggestActivityOption}
        />
      )}
    </div>
  );
};

export default AiSuggestActivityButton;
